
import {
  displayNameFacet,
  folderFacet,
  fileNameFacet,
  missingMetadataFacet,
  vroomUrlFacet,
  fileSizeFacet,
  eTagFacet
} from '@ms/items-view/lib/private/facets/ItemFacets';

import {
  childItemsFacet,
  defaultChildItemSetFacet,
  parentItemFacet,
  schemaFacet
} from '@ms/items-view/lib/private/facets/SetFacets';

import {
  supportFacets, resolveItems
} from '@ms/items-view/lib/private/operations/getItems';

import {
  folderPathFacet,
  filterOptionSetFacet,
  listSchemaFacet,
  missingMetadataFieldsFacet,
  uniqueIdFacet,
  spFilterableSetFacet,
  getItemResponseJsonStringFacet
} from './Facets';

import {
  spPinnedItemSetKeyFacet,
  spViewKeyFacet,
  spListViewsSetKeyFacet,
  spNeedsAttentionItemKeyFacet,
  customActionKeyFacet,
  contextMenuCustomActionSetKeyFacet,
  spPersonKeyFacet,
  spFieldKeyFacet
} from './Keys';

import {
  spItemKeyFacet,
  spFolderItemSetKeyFacet,
  spListKeyFacet,
  spPageContextKeyFacet
} from './Keys';

import { blockItemPageKeyFacet } from '@ms/items-view/lib/private/operations/blockItemPage';
import { customFormatterFeatureKeyFacet } from '../models/facets/CustomFormatterFacets';
import { driveItemKeyFacet } from '@ms/items-view-addon-graph/lib/models/keys/DriveItemKeyFacet';
import { IAddon, createAddon } from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch, IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import * as RUMOneHelper from '../utilities/logging/performance/RUMOneHelper';

import { registerPermanentItemDemands } from '@ms/items-view/lib/private/operations/pruneItems';
import {
  resetPerfLoggerKeyFacet,
  internalPerfLoggerKeyFacet,
  resetPerfLoggerFacet,
  IMeasurementInfo,
  internalPerfLoggerFacet,
  loggerFacet
} from '@ms/items-view/lib/private/facets/LoggerFacets';
import { readConfiguration } from '@ms/items-view/lib/private/operations/configuration/readConfiguration';

export const SPCoreAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    dispatch(initializeRUMOne());

    dispatch(supportFacets({
      keyFacet: customFormatterFeatureKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spFolderItemSetKeyFacet,
      facets: [
        childItemsFacet,
        schemaFacet,
        parentItemFacet,
        filterOptionSetFacet,
        spFilterableSetFacet,
        listSchemaFacet,
        getItemResponseJsonStringFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spItemKeyFacet,
      facets: [
        spItemKeyFacet,
        displayNameFacet,
        fileNameFacet,
        driveItemKeyFacet,
        uniqueIdFacet,
        vroomUrlFacet,
        fileSizeFacet,
        folderFacet,
        folderPathFacet,
        defaultChildItemSetFacet,
        missingMetadataFieldsFacet,
        eTagFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spNeedsAttentionItemKeyFacet,
      facets: [
        missingMetadataFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spListViewsSetKeyFacet,
      facets: [
        childItemsFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spPageContextKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spListKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spViewKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: customActionKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spPinnedItemSetKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: contextMenuCustomActionSetKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spPersonKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: spFieldKeyFacet,
      facets: []
    }));

    dispatch(supportFacets({
      keyFacet: blockItemPageKeyFacet,
      facets: []
    }));
  };
});

function initializeRUMOne(): IItemCacheThunkAction<void> {
  return (dispatch: IItemCacheDispatch) => {
    const {
      spLoggerConfiguration
    } = dispatch(readConfiguration({
      spLoggerConfiguration: loggerFacet
    }));

    const {
      scenarioId = ''
    } = spLoggerConfiguration || {};
    const {
      resetRUMOne,
      logRUMOneForItemsView
    } = RUMOneHelper;
    const resetPerfLoggerKey = resetPerfLoggerKeyFacet.serialize({});
    const internalPerfLoggerKey = internalPerfLoggerKeyFacet.serialize({});
    dispatch(resolveItems({
      items: {
        [resetPerfLoggerKey]: {
          ...resetPerfLoggerFacet.pack((measurementInfo: IMeasurementInfo | undefined) => {
            dispatch(resetRUMOne(measurementInfo));
          })
        },
        [internalPerfLoggerKey]: {
          ...internalPerfLoggerFacet.pack((renderEndTime: number, measurementInfo: IMeasurementInfo | undefined) => {
            dispatch(logRUMOneForItemsView(renderEndTime, scenarioId, measurementInfo));
          })
        }
      }
    }));
    dispatch(registerPermanentItemDemands({
      items: {
        [resetPerfLoggerKey]: {}
      }
    }));
  };
}